angular.module("vgresiduos").controller("JobAreaCtrl", [
	"$scope",
	"$rootScope",
	"$q",
	"httpService",
	"jobPositionService",
	function ($scope, $rootScope, $q, httpService, jobPositionService) {
		"use strict";

		const labels = $rootScope.labels;
		let isListLoaded;

		this.$onInit = function () {
			initLabel();

			$scope.helpInfo = $scope.$ctrl.helpInfo ? $scope.$ctrl.helpInfo : null;
			loadJobAreas().then(setJobArea);
		};

		function initLabel() {
			$scope.label = $scope.$ctrl.label ? $scope.$ctrl.label : labels.JOB_AREA;

			if ($scope.$ctrl.isRequired) {
				$scope.label += "*";
			}
		}

		function loadJobAreas() {
			const deferred = $q.defer();

			if (isListLoaded) {
				deferred.resolve();
				return deferred.promise;
			}

			httpService.getListFromServiceCore(jobPositionService.getJobPositionAreas).then(
				function (response) {
					$scope.jobAreas = response.list;
					isListLoaded = true;
					deferred.resolve();
				},
				function () {
					deferred.reject();
				}
			);

			return deferred.promise;
		}

		function setJobArea() {
			if ($scope.$ctrl.setterId) {
				const foundArea = $scope.jobAreas.find((area) => area.id == $scope.$ctrl.setterId);
				if (foundArea) {
					$scope.$ctrl.model = foundArea.id;
				}
			} else if ($scope.$ctrl.selectAutoWhenOneOption && $scope.jobAreas.length == 1) {
				$scope.$ctrl.model = $scope.jobAreas[0].id;
			}
		}

		$scope.isDisabled = function () {
			return $scope.$ctrl.isDisabled ? $scope.$ctrl.isDisabled : false;
		};

		$scope.$watch("$ctrl.setterId", function (newValue, oldValue) {
			const modelId = $scope.$ctrl.model;

			if (newValue != modelId) {
				loadJobAreas().then(setJobArea);
			}
		});
	}
]);
